import { useTranslation } from 'react-i18next';
import { EngagementDetail } from '@anytag/graphql';
import { ChartsContainer, NoDataTitle } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { AgeBreakdownChart, GenderBreakdownChart, SingleAreaBreakdownChart } from '@anytag/shared-molecules';
import { Option } from '@anytag/shared-types';

interface TemplateProps {
  engagement: EngagementDetail;
  ageOptions?: Option<number>[];
  areaOptions?: Option<number>[];
  genderRates?: { maleRate: number; femaleRate: number };
  ageGenderRates?: {
    maleRates: readonly number[];
    femaleRates: readonly number[];
    ageGroups: readonly { start: number; end: number }[];
  };
}

export const Template = ({
  genderRates,
  ageGenderRates,
  ageOptions = [],
  areaOptions = [],
  engagement: { isTtcmCampaign }
}: TemplateProps) => {
  const { t } = useTranslation();

  return (
    <div css={{ backgroundColor: THEME.background.colors.white, borderTop: THEME.border.base }}>
      <p css={{ fontSize: '18px', padding: '16px', borderBottom: '1px solid #e6ecf0' }}>
        {t(isTtcmCampaign ? 'Video view audience' : 'YouTube Video Audience Breakdown')}
      </p>

      <ChartsContainer
        elements={[
          <GenderBreakdownChart {...genderRates} />,

          isTtcmCampaign ? (
            <SingleAreaBreakdownChart valueOptions={ageOptions} />
          ) : (
            <AgeBreakdownChart
              ageGroup={ageGenderRates?.ageGroups}
              maleRate={ageGenderRates?.maleRates}
              femaleRate={ageGenderRates?.femaleRates}
              header={<NoDataTitle css={{ marginBottom: '15px' }} title={t('BasicInfo.Age')} />}
            />
          )
        ]}
      />
    </div>
  );
};
